// export const MAVIS_NOTE_ACCESS_FOR_EDITORS = [667]; // (Jeoff id :667)  for access mavis note Edit

const DIP_COMMON_PEOPLE = [
  'richard.deloughy@dealerimagepro.com',
  'richard@dealerimagepro.com',
  'peter@dealerimagepro.com',
  'chris.thomas@dealerimagepro.com'
];

export const DEVELOPERS_ACCESS = [
  'ankita.bhadeshiya@eryushion.com',
  'eryushion.techsol@gmail.com',
  'ravi.rathod@eryushion.com',
  'kashmeera.kadachhi@eryushion.com',
  'vimal14569@gmail.com',
  'vimal.ghorecha@dealerimagepro.com',
  'hiren.bhindi@eryushion.com',
  'aniruddh.purohit@dealerimagepro.com',
  'uday.odedara@eryushion.com'
];

// export const MANGERS_ACCESS = ['vimal.ghorecha@dealerimagepro.com', 'aniruddh.purohit@dealerimagepro.com'];

// export const DIRECT_LOGIN_ACCESS = [
//   'richard.deloughy@dealerimagepro.com',
//   'richard@dealerimagepro.com',
//   'eduardo.ramirez@dealerimagepro.com',
//   ...DEVELOPERS_ACCESS
// ];

export const VIDEO_GENERATION_PAGE_ACCESS_FOR_USER = [
  'westerliestrade@gmail.com',
  'eduardo.ramirez@dealerimagepro.com',
  'yuchen.huang@dealerimagepro.com',
  ...DIP_COMMON_PEOPLE,
  ...DEVELOPERS_ACCESS
];

// export const EDIT_IMS_ID_ACCESS_DEALERPROFILE = [
//   ...DIP_COMMON_PEOPLE,
//   ...DEVELOPERS_ACCESS,
//   'eduardo.ramirez@dealerimagepro.com',
//   'yocelin.arriaga@dealerimagepro.com',
//   'yuchen.huang@dealerimagepro.com'
// ];

// export const CANCEL_BTN_ACCESS_DEALERPROFILE = [
//   'cameron@dealerimagepro.com',
//   'alondra@dealerimagepro.com',
//   'jason.eisenberg@dealerimagepro.com',
//   'eduardo.ramirez@dealerimagepro.com',
//   'yuchen.huang@dealerimagepro.com',
//   ...DIP_COMMON_PEOPLE,
//   ...DEVELOPERS_ACCESS
// ];

// export const YOUTUBE_ACCESS_FOR_USER = ['demo@demo.com', ...DEVELOPERS_ACCESS];

// export const REPROCESS_VEHICLES_ACCESS = [
//   'richard.deloughy@dealerimagepro.com',
//   'richard@dealerimagepro.com',
//   ...DEVELOPERS_ACCESS
// ];

export const QC_AND_AUTO_PUBLISH_QC_ACCESS = [
  // 'richard.deloughy@dealerimagepro.com',
  // 'richard@dealerimagepro.com',
  ...DEVELOPERS_ACCESS
];

// export const RATIO_CHANGE_ACCESS = [
//   'richard.deloughy@dealerimagepro.com',
//   'richard@dealerimagepro.com',
//   'eduardo.ramirez@dealerimagepro.com',
//   ...DEVELOPERS_ACCESS
// ];

// export const PROMO_DEALER_ACCESS = [37, 3981, 3983, 3984, 3982];

export const SERVICE_INDICATOR_DATE_RANGE_SELECTOR_ACCESS = [
  'richard.deloughy@dealerimagepro.com',
  'rafael@dealerimagepro.com',
  'ryan.nieto@dealerimagepro.com',
  ...DEVELOPERS_ACCESS
];

export const DEALERSHIP_USAGE_DOWNLOAD_ACCESS = [
  'richard.deloughy@dealerimagepro.com',
  'ryan.nieto@dealerimagepro.com',
  'jason.eisenberg@dealerimagepro.com',
  ...DEVELOPERS_ACCESS
];

export const REPOCESS_ALL_VIDEO_ACCESS = [
  'richard.deloughy@dealerimagepro.com',
  'eduardo.ramirez@dealerimagepro.com',
  'ryan.nieto@dealerimagepro.com',
  'cameron@dealerimagepro.com',
  ...DEVELOPERS_ACCESS
];

// export const WINDOW_STICKER_PRICING_ACCESS = [
//   'ryan.nieto@dealerimagepro.com',
//   'cameron@dealerimagepro.com',
//   'richard.deloughy@dealerimagepro.com',
//   ...DEVELOPERS_ACCESS
// ];
